var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.75 10.689 6.47-6.47a.749.749 0 1 1 1.06 1.06l-6.47 6.47 6.47 6.47a.749.749 0 1 1-1.06 1.06l-6.47-6.468-6.47 6.469a.749.749 0 1 1-1.06-1.06l6.469-6.47-6.47-6.47a.749.749 0 1 1 1.06-1.06l6.47 6.469z",
    fill: "currentColor"
  })));
};
export default SvgX;